import type { DecoratorBody } from "../page-decorators";

export const hydrationBadgeDecorator: DecoratorBody = {
  attach($host: HTMLElement): void {
    if ($host.querySelector('[data-page-decorator="lona.hydration-badge"]')) {
      return;
    }

    const $badge = document.createElement("div");
    $badge.dataset.pageDecorator = "lona.hydration-badge";
    $badge.textContent = "Hydrated";
    $badge.style.cssText = [
      "position:fixed",
      "right:12px",
      "bottom:12px",
      "z-index:2147483647",
      "padding:6px 8px",
      "border:1px solid var(--divider)",
      "border-radius:6px",
      "background:var(--bg)",
      "color:var(--text-sec)",
      "font:12px/1.2 system-ui, sans-serif",
      "box-shadow:var(--surface-shadow, 0 4px 8px rgba(0,0,0,0.2))",
    ].join(";");
    $host.appendChild($badge);
  },
  detach: null,
};
